const pagination = (listData, cnt, curPageNum, dataPerPage) => {
    listData = listData.map((v, index)=> v = Object.assign(v,{indexNo:(cnt - index) - ((curPageNum-1)*dataPerPage)}));
    return listData;
};

export default pagination;